import { render, staticRenderFns } from "./edition-icons.vue?vue&type=template&id=4545ae1a&scoped=true&"
import script from "./edition-icons.vue?vue&type=script&lang=ts&"
export * from "./edition-icons.vue?vue&type=script&lang=ts&"
import style0 from "./edition-icons.vue?vue&type=style&index=0&id=4545ae1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4545ae1a",
  null
  
)

export default component.exports